<template>
  <span @click="go('im')">
    <slot></slot>
  </span>
</template>

<script>
import { clientIf } from '@/api/xiaopei/down'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '@/libs/util'
import {
  getgoodsdetails,
  rmCustomerService,
  transmitorder,
  sendparticulars
} from '@/api/xiaopei/index'
export default {
  props: {
    oppositeTenantId: String,
    partId: String,
    orderId: String
  },
  methods: {
    async go(type) {
      // return false
      let routeData = ''
      console.log(type)
      switch (type) {
        //   case 'message':
        //     routeData = this.$router.resolve({ path: '/platformMessage' })
        //     window.open(routeData.href, '_blank')
        //     break
        //   case 'car':
        //     routeData = this.$router.resolve({ path: '/shoppingCart' })
        //     window.open(routeData.href, '_blank')
        //     break
        case 'im':
          const res2 = await getgoodsdetails()
          console.log(res2)
          let url2 = res2.data.url
          let name = JSON.parse(localStorage.getItem('userData')).username
          // console.log(name)
          let token = Cookies.get(TOKEN_KEY)
          rmCustomerService({ oppositeTenantId: this.oppositeTenantId }).then(
            res => {
              console.log(res)
              if (res.status) {
                let loginName = res.data.loginName
                // getRmChat({ loginName: res.data.loginName }).then(res => {
                // console.log(res)
                clientIf(
                  name,
                  url2 + '/rm-order',
                  res.data.userId,
                  token,
                  loginName
                )
                if (this.partId) {
                  setTimeout(() => {
                    transmitorder({
                      partId: this.partId,
                      buyerId: this.oppositeTenantId
                    })
                  }, 3500)
                }
                if (this.orderId) {
                  setTimeout(() => {
                    sendparticulars({
                      orderId: this.orderId,
                      tenantId: this.oppositeTenantId
                    })
                  }, 3500)
                }
                // })
              }
            }
          )

          break
          if (!sessionStorage.getItem('userData')) {
            return this.$router.push('/login')
          }
          var kefuType = {
            // 客服组类型
            0: '综合',
            1: '译码',
            2: '订单',
            3: '财务',
            4: '售后',
            5: '物流',
            6: '第三方门店'
          }
          await deleteCount()
          getKefus({
            id: sessionStorage.getItem('userId'),
            storeCode: '00001',
            groupType: '0'
          }).then(res => {
            res.customerList =
              Array.isArray(res.customerList) &&
              res.customerList.filter(el => {
                return el.status != 0
              })
            if (!(res.customerList && Array.isArray(res.customerList))) {
              this.$message.warning('暂无客服人员!')
              return
            }
            kefus =
              res.customerList.map(el => {
                el.id = el.userId
                el.company = el.companyName
                el.storeName = el.companyName
                  ? el.companyName
                  : el.storeName
                  ? el.storeName
                  : '匿名企业'
                el.username = el.loginName
                el.fullname = kefuType[el.groupType] + '组' + el.userName
                if (el.avatar && el.avatar.length > 6) {
                  el.avatar = urlObj.endurl + el.avatar
                }
                return el
              }) || []
            let currkefuid = kefus[0].id
            sessionStorage.currkefuid = currkefuid
            if (!sessionStorage.kefus) {
              sessionStorage.setItem('kefus', JSON.stringify(kefus))
            } else {
              let hash = {}
              kefus = [...kefus, ...JSON.parse(sessionStorage.getItem('kefus'))]
              const data2 = kefus.reduce((preVal, curVal) => {
                hash[curVal.id]
                  ? ''
                  : (hash[curVal.id] = true && preVal.push(curVal))
                return preVal
              }, [])
              sessionStorage.setItem('kefus', JSON.stringify(data2))
            }
            if (localStorage.open) {
              localStorage.open = parseInt(localStorage.open) + 1
            } else {
              localStorage.open = 1
            }
            window.open(`${origin}/ims/font/im.html`, '_blank')
          })
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
span {
  cursor: pointer;
}
// .icon-a-lujing162 {
//   color: #0077ff;
//   font-size: 18px;
//   cursor: pointer;
// }
</style>
